module.exports = __webpack_public_path__ + "assets/头像.c360eda4.svg";